import axios from "axios";
import {get} from './CrudControllers'
import { getFormatInputFecha } from "../helpers/dates";

const bdaxios = axios.create({
    baseURL: process.env.REACT_APP_BASEURL,
});


export class Pueblo {

    id = ''
    nombre = ''
    provincia = ''
    ubicacion = ''
    hora = '00:00'
    fecact = getFormatInputFecha(new Date())
    fecopen = getFormatInputFecha(new Date())
    fecclose = getFormatInputFecha(new Date())
    
    getVillages1 (){
        get('villages');
    }
    
    
    async getVillages() {
        try {
            const res = await bdaxios.get('/villages')
            return res.data;
        } catch (error) {
            if (error.response.status === 404) 
                throw new Error(error.response.data.message)
            throw new Error(error.message )
        }

    }
    async addVillage(village, token) {
        try {
            await bdaxios({
                method: 'POST',
                url: '/villages',
                headers: {
                    Authorization: 'Bearer ' + token.value,
                },
                data: village
            });
        } catch (error) {
            if (error.response.status === 400) 
                throw (error.response.data.errors[0].msg)
            throw new Error(error.message)
        }
       
        return this.getVillages();
    }

    async updateVillage(village, token) {
        await bdaxios({
            method: 'PATCH',
            url: '/villages/' + village.id,
            headers: {
                Authorization: 'Bearer ' + token.value,
            },
            data: village
        });
        return this.getVillages();
    }

    async delVillage(id, token) {
        await bdaxios({
            method: 'DELETE',
            url: '/villages/' + id,
            headers: {
                Authorization: 'Bearer ' + token.value,
            },
        });
        return this.getVillages();
    }



}
